var _g, _path, _path2, _g2, _rect, _rect2, _path3, _path4, _path5, _path6, _rect3, _g3, _path7, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 128,
    viewBox: "0 0 148 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1121_4046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39 13.1914H93.6125C101.897 13.1914 108.612 19.9071 108.612 28.1914V82.6197C108.612 90.904 101.897 97.6197 93.6124 97.6197H39C30.7157 97.6197 24 90.904 24 82.6197V28.1914C24 19.9071 30.7157 13.1914 39 13.1914Z",
    fill: "white",
    stroke: "#E5E5E5",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1121_4046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.145 84.8492H60.8251V58.2256H34.145V84.8492ZM39.4806 63.5507H55.4889V79.4836H39.4806V63.5507Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8169 68.875H50.1528V74.2003H44.8169V68.875ZM76.8321 79.525H82.1693V84.8497H76.8321V79.525ZM87.5042 79.525H92.8413V84.8497H87.5042V79.525Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5048 63.5509H82.1692V58.2258H66.1605V84.8494H71.497V68.8752H76.8322V74.2004H92.8409V58.2258H87.5048V63.5509ZM34.145 52.9022H60.8251V26.2783H34.145V52.9022ZM39.4806 31.6026H55.4889V47.5768H39.4806V31.6026Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8169 36.9276H50.1528V42.2526H44.8169V36.9276ZM66.1605 26.2783V52.9022H92.8413V26.2783H66.1605ZM87.5048 47.5768H71.497V31.6026H87.5048V47.5768Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.832 36.9277H82.1678V42.2527H76.832V36.9277Z",
    fill: "#333333"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.1504 54.2022L57.4816 89.4382C57.4816 89.4382 57.4816 96.7513 60.4797 100.408C63.4779 104.064 65.5486 106.724 65.5486 106.724V127.998L99.2578 127.998V106.724L110.325 99.4589L64.1441 59.8532C64.1441 59.8532 62.7083 53.5681 54.1504 54.2022Z",
    fill: "#E28F5E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1121_4046",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 54,
    y: 54,
    width: 57,
    height: 74
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1503 54.2041C53.9309 66.5744 58.184 92.7913 58.184 92.7913C58.184 92.7913 57.7389 98.4083 59.9679 100.935C62.1969 103.462 65.5485 104.576 65.5485 104.576V128L99.2577 128V106.726L110.325 99.4608L64.144 59.8551C64.144 59.8551 62.7082 53.57 54.1503 54.2041Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1121_4046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.1435 106.061H109.45V56.8633H66.1436V95.0609C66.1436 101.136 71.0684 106.061 77.1435 106.061Z",
    fill: "#B3693E"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 64.1445,
    y: 7,
    width: 51.3012,
    height: 96.4008,
    rx: 10,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 66.1436,
    y: 8.99512,
    width: 47.3037,
    height: 92.4118,
    rx: 8,
    fill: "#19184A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5756 11.0947C90.2235 11.0947 89.8793 11.1989 89.5866 11.3942C89.2938 11.5894 89.0657 11.8669 88.9309 12.1916C88.7962 12.5163 88.7609 12.8735 88.8296 13.2182C88.8983 13.5629 89.0678 13.8795 89.3168 14.128C89.5658 14.3765 89.883 14.5457 90.2283 14.6143C90.5736 14.6828 90.9315 14.6476 91.2568 14.5131C91.5821 14.3787 91.8601 14.1509 92.0557 13.8587C92.2513 13.5665 92.3557 13.223 92.3557 12.8716C92.3557 12.4003 92.1682 11.9484 91.8343 11.6152C91.5005 11.2819 91.0477 11.0947 90.5756 11.0947Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110.991 66.2444C106.828 62.0902 106.828 55.3551 110.991 51.2009L116.644 45.5596L118.519 47.4305C121.647 50.5514 121.647 55.6113 118.519 58.7322L110.991 66.2444Z",
    fill: "#E28F5E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112.323 80.2073C108.16 76.0531 108.16 69.318 112.323 65.1638L117.976 59.5225L119.851 61.3934C122.979 64.5143 122.979 69.5742 119.851 72.6951L112.323 80.2073Z",
    fill: "#E28F5E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M112.323 95.4983C108.16 91.3442 108.16 84.609 112.323 80.4548L117.976 74.8135L119.851 76.6844C122.979 79.8053 122.979 84.8652 119.851 87.9861L112.323 95.4983Z",
    fill: "#E28F5E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 73.4634,
    y: 36.917,
    width: 33.3125,
    height: 33.2416,
    rx: 3,
    fill: "white",
    fillOpacity: 0.3
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1121_4046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.779 42.9014H79.459V64.176H100.779V42.9014Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_1121_4046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.438 61.1239H89.1924V54.3838H82.438V61.1239ZM83.7888 55.7319H87.8415V59.7656H83.7888V55.7319Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1396 57.0801H86.4905V58.4282H85.1396V57.0801ZM93.2448 59.7763H94.596V61.1243H93.2448V59.7763ZM95.9466 59.7763H97.2977V61.1243H95.9466V59.7763Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9468 55.732H94.596V54.3839H90.5432V61.124H91.8942V57.0799H93.2449V58.4281H97.2977V54.3839H95.9468V55.732ZM82.438 53.0361H89.1924V46.2959H82.438V53.0361ZM83.7888 47.6438H87.8415V51.6879H83.7888V47.6438Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1396 48.9919H86.4905V50.34H85.1396V48.9919ZM90.5431 46.2959V53.0361H97.2977V46.2959H90.5431ZM95.9467 51.6879H91.8941V47.6438H95.9467V51.6879Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2446 48.9922H94.5951V50.3403H93.2446V48.9922Z",
    fill: "#333333"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4712 42.2357V39.917C73.4712 38.2601 74.8143 36.917 76.4712 36.917H78.7998",
    stroke: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M106.784 42.2357V39.917C106.784 38.2601 105.441 36.917 103.784 36.917H101.456",
    stroke: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4712 64.8386V67.1572C73.4712 68.8141 74.8143 70.1572 76.4712 70.1572H78.7998",
    stroke: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M106.784 64.8386V67.1572C106.784 68.8141 105.441 70.1572 103.784 70.1572H101.456",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1121_4046"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 12.1914,
    width: 86.6124,
    height: 86.4283,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1121_4046"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58.6963,
    height: 58.5715,
    fill: "white",
    transform: "translate(34.145 26.2783)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1121_4046"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.459,
    y: 42.9014,
    width: 21.32,
    height: 21.2747,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_1121_4046"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.8598,
    height: 14.8282,
    fill: "white",
    transform: "translate(82.438 46.2959)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qrCode.731aca645dec6f1b91a6c7eefa4cbf1b.svg";
export { ForwardRef as ReactComponent };